"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateTarget = exports.LinkTarget = void 0;
var LinkTarget;
(function (LinkTarget) {
    LinkTarget["Self"] = "_self";
    LinkTarget["Blank"] = "_blank";
    LinkTarget["Parent"] = "_parent";
    LinkTarget["Top"] = "_top";
})(LinkTarget = exports.LinkTarget || (exports.LinkTarget = {}));
const validateTarget = (target, supportedTargets, defaultTarget) => {
    return supportedTargets.includes(target) ? target : defaultTarget;
};
exports.validateTarget = validateTarget;
